import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-80e04532"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "view add-user" }
const _hoisted_2 = { class: "add-user__header" }
const _hoisted_3 = { class: "add-user__header-left" }
const _hoisted_4 = { class: "add-user__title" }
const _hoisted_5 = { class: "add-user__header-right add-user__header-buttons" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "button button--red" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "material-icons left" }, "close"),
  /*#__PURE__*/_createTextVNode(" Therapy reset")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons left" }, "delete_outline", -1))
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Delete user")
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = { class: "add-user__form-panel" }
const _hoisted_11 = { class: "add-user__form-section" }
const _hoisted_12 = { class: "add-user__form-box" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "add-user__headline" }, "Informations", -1))
const _hoisted_14 = { class: "add-user__status" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" STATUS: ")
const _hoisted_16 = /*#__PURE__*/_createTextVNode()
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "name" }, "User type", -1))
const _hoisted_18 = {
  class: "add-user__switch-label",
  for: "debug"
}
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Debug option ")
const _hoisted_20 = { class: "add-user__accept" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode("The user has accepted the processing of personal data ")
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "add-user__bot-buttons" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "button button--big button--green" }, "Save Changes")
], -1))
const _hoisted_23 = { class: "add-user__form-section" }
const _hoisted_24 = { class: "add-user__form-box" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "add-user__headline" }, "Groups", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "add-user__text add-user__text--groups" }, "Add your user to specific group", -1))
const _hoisted_27 = { class: "groups" }
const _hoisted_28 = { class: "add-user__form-box" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "add-user__headline" }, "Login history", -1))
const _hoisted_30 = { class: "log-box" }
const _hoisted_31 = { class: "log-box__list" }
const _hoisted_32 = /*#__PURE__*/_createStaticVNode("<div class=\"log-box__list-head\" data-v-80e04532><div class=\"log-box__list-row\" data-v-80e04532><div class=\"log-box__list-cell name\" data-v-80e04532>Name</div><div class=\"log-box__list-cell date\" data-v-80e04532>Date</div><div class=\"log-box__list-cell status\" data-v-80e04532>Status</div></div></div>", 1)
const _hoisted_33 = { class: "log-box__list-body" }
const _hoisted_34 = { class: "log-box__list-cell name" }
const _hoisted_35 = { class: "log-box__list-cell date" }
const _hoisted_36 = { class: "log-box__list-cell status" }
const _hoisted_37 = { class: "log-box__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Switch = _resolveComponent("Switch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.user.email), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("button", {
          class: "button button--red",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.deleteUser(_ctx.user.externalId)), ["prevent"]))
        }, _hoisted_9)
      ])
    ]),
    _createElementVNode("form", {
      onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createElementVNode("i", {
                class: _normalizeClass(["material-icons add-user__status-icon", _ctx.userStatus])
              }, _toDisplayString(_ctx.statusIcon), 3),
              _hoisted_16,
              _createElementVNode("span", {
                class: _normalizeClass(["add-user__status-text", _ctx.userStatus])
              }, _toDisplayString(_ctx.userStatus), 3)
            ]),
            _hoisted_17,
            _createVNode(_component_Dropdown, {
              modelValue: _ctx.user.userType,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.user.userType) = $event)),
              disabled: true,
              options: _ctx.userTypeOptions,
              optionLabel: "label",
              optionValue: "value",
              placeholder: "User type",
              class: "drop"
            }, null, 8, ["modelValue", "options"]),
            _createElementVNode("label", _hoisted_18, [
              _hoisted_19,
              _createVNode(_component_Switch, {
                modelValue: _ctx.user.isTester,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.user.isTester) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("p", _hoisted_20, [
              _hoisted_21,
              _createElementVNode("i", {
                class: _normalizeClass(["material-icons add-user__status-icon", _ctx.userStatus])
              }, _toDisplayString(_ctx.statusIcon), 3)
            ])
          ]),
          _hoisted_22
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            _hoisted_26,
            _createElementVNode("div", _hoisted_27, [
              _createVNode(_component_Dropdown, {
                modelValue: _ctx.user.group,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.user.group) = $event)),
                options: _ctx.groups,
                optionLabel: "name",
                placeholder: _ctx.user.group ? _ctx.user.group.name : 'Select a group',
                class: "drop",
                filter: true,
                filterPlaceholder: "Find a group"
              }, null, 8, ["modelValue", "options", "placeholder"])
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _hoisted_29,
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _hoisted_32,
                _createElementVNode("div", _hoisted_33, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.audit, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "log-box__list-row",
                      key: item?.externalId
                    }, [
                      _createElementVNode("div", _hoisted_34, _toDisplayString(item.details), 1),
                      _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.returnDate(item.created)), 1),
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("i", {
                          class: _normalizeClass(["material-icons", item.action === 'LoginSuccess' ? 'green' : 'red'])
                        }, _toDisplayString(item.action === 'LoginSuccess' ? 'check_circle' : 'cancel'), 3)
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("button", {
              class: "button button--green",
              onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.goToLog && _ctx.goToLog(...args)), ["prevent"]))
            }, "See complete log")
          ])
        ])
      ])
    ], 32)
  ]))
}